["MANDATAIRE", "REPRESENTANT_LEGAL", "DELEGUE", "VISITEUR"]
